import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { InitializeTicket } from "../../Apis/AuthApiServices";
import {
  loadingInitialTicket,
  setInitialTicket,
} from "../Slice/InitializeTicket";

function* onLoadInitialTicketAsync({ payload }: any) {
  const params = new URLSearchParams();
  let doctorId: any = localStorage.getItem("doctorId");
  params.append("doctorId", doctorId);

  try {
    const result: AxiosResponse = yield InitializeTicket(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setInitialTicket({
          InitializeTicketData: result?.data?.response[0],
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setInitialTicket({
          InitializeTicketData: [],
          error: false,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error) {
    yield put(
      setInitialTicket({
        InitializeTicketData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadInitialTicket() {
  yield takeLatest(loadingInitialTicket.type, onLoadInitialTicketAsync);
}

const InitializeTicketSaga = [fork(onLoadInitialTicket)];
export default InitializeTicketSaga;
